import fdb_storage_adapter from './frfr-frontend-db-storage-adapter';
import { json_utils } from './frfr-json-utils';
import { js_utils } from './frfr-js-utils';


const frfr_lib_changes_id = '/FRFR/frfr-frontend-db.js/changes_id2023-01-17/';
// NOVO privremeni boost cuvanje u var privremeno umesto u storage
/* 
FrFr FRIENDLY FRAMEWORK
frfr-frontend-db FRONTEND DATABASE
Version 1a 2023-01-17
by 
// Please describe here if you customized this file
*/

/*
TODO
*/

/*
KORACI:
- queue se zakljucava
- citanje baze iz localstorage
- prosledjivanje baze CRUD funkcijama koje mutiraju bazu
- mutirajuce funkcije daju kao rezultat mutiranu bazu
- upisivanje mutirane baze u local storage
- queue item je zavrsen
- ...dalje ili queue se ponovo otkljucava zatim se automatski pokusava advance na sledeci item
*/

const DEFAULT_FDB_KEY = 'untitled_fdb_database'; // ??? initial database local storage key


const GET = 'GET';
const MUTATE = 'MUTATE';
const COMBO = 'COMBO';
const ADVANCED_SWAP = 'ADVANCED_SWAP';
let fdb_engine = {};
fdb_engine.locked = false; // database queue locked
fdb_engine.queue = [];
fdb_engine.db_in_vars = {}; // advanced databases in memory (not stored into localstorage)
fdb_engine.db_in_temp_vars = {}; // NEW temp boost databases in memory instead in localstorage
fdb_engine.advanced_swap_enabled_db_keys = {}; // NEW temp boost enabled databases keys
fdb_engine.counter = 0; // transactions counter

fdb_engine.get_fresh_transaction_id = function () {
  fdb_engine.counter++;
  return 't' + fdb_engine.counter;
};


fdb_engine.db_grab_from_var = async function (db_key) {
  // get whole database object from memory (var)
  // console.log('fdb_engine.db_grab_from_var(db_key) - db_key: ', db_key);
  const decoded = fdb_engine.db_in_vars[db_key];
  // console.log('GRABBED from memory');
  // console.log(decoded);
  return decoded;
};
fdb_engine.db_grab_from_temp_var = async function (db_key) {
  // get whole database object from memory (var) TEMP
  const raw = fdb_engine.db_in_temp_vars[db_key];
  const decoded = json_utils.decode_if_json(raw);
  return decoded;
};
fdb_engine.db_grab_from_storage = async function (db_key) {
  // get whole database object from localstorage
  let raw = await fdb_storage_adapter.get(db_key);
  // let decoded = null;
  const decoded = json_utils.decode_if_json(raw);
  // return decoded;
  // console.log('GRABBED and decoded from storage');
  // console.log(decoded);
  return decoded;
};
fdb_engine.db_grab = async function (db_key, dont_store) {
  // get whole database object
  let db;
  let decoded;
  if (dont_store === true) {
    // CASE from memory (var)
    decoded = await fdb_engine.db_grab_from_var(db_key);
  } else {
    // get whole database object from localstorage
    if (fdb_engine.advanced_swap_enabled_db_keys[db_key] === true) {
      // ADVANCED TEMP BOOST
      decoded = await fdb_engine.db_grab_from_temp_var(db_key);
    } else {
      decoded = await fdb_engine.db_grab_from_storage(db_key);
    }
  }
  // console.log('GRABBED decoded: ');
  // console.log(decoded);
  if (js_utils.is_object(decoded)) {
    db = decoded;
  } else {
    db = false; // if not object return false
  }
  // console.log('GRABBED final: ');
  // console.log(db);
  return db;
};


fdb_engine.db_write_to_var = async function (db, db_key) {
  // write whole database in memory (var)
  // console.log('fdb_engine.db_write_to_var(db, db_key) - db_key: ', db_key);
  // console.log(db);
  fdb_engine.db_in_vars[db_key] = db;
  // console.log('*** fdb_engine WRITE IN VAR FINISHED');
  // console.log(fdb_engine.db_in_vars);
  return true;
};
fdb_engine.db_write_to_temp_var = async function (db, db_key) {
  // write whole database in memory (var) TEMP
  const json = JSON.stringify(db);
  fdb_engine.db_in_temp_vars[db_key] = json;
  return true;
};
fdb_engine.db_write_to_storage = async function (db, db_key) {
  // write whole database in localstorage
  // console.log('fdb_engine.db_write_to_storage(db, db_key) - db_key: ', db_key);
  // console.log(db);
  const json = JSON.stringify(db);
  // console.log('JSON encoded before write');
  // console.log(json);
  const a = await fdb_storage_adapter.set(db_key, json);
  // console.log('*** fdb_engine WRITE FINISHED');
  return true;
};
fdb_engine.db_write = async function (db, db_key, dont_store) {
  // write whole database in localstorage
  // console.log(db);
  let a;
  if (dont_store === true) {
    // CASE from memory (var)
    a = await fdb_engine.db_write_to_var(db, db_key);
  } else {
    // CASE from localstorage
    if (fdb_engine.advanced_swap_enabled_db_keys[db_key] === true) {
      // ADVANCED TEMP BOOST
      a = await fdb_engine.db_write_to_temp_var(db, db_key);
    } else {
      a = await fdb_engine.db_write_to_storage(db, db_key);
    }
  }
  return true;
};


fdb_engine.db_delete = async function (db_key, dont_store) {
  // delete entire database
  let a;
  if (dont_store === true) {
    // CASE from memory (var)
    delete fdb_engine.db_in_vars[db_key]; // DELETE VAR PROPERTY OF DATABASE
    console.log('database deleted from memory');
  } else {
    // CASE from localstorage
    a = await fdb_storage_adapter.delete(db_key); // DELETE DB FROM LOCALSTORAGE
    console.log('database deleted from localstorage');
  }
  return true;
};


fdb_engine.queue_advance = function () {
  // ADVANCE
  // QUEUE ADVANCE MUST USE CALLBACKS, NOT ASYNC
  // let greenlight = true;
  if (fdb_engine.locked === false && fdb_engine.queue.length > 0) {
    fdb_engine.locked = true; // LOCK
    let qitem = fdb_engine.queue.shift();
    if (qitem) {
      const on_qitem_finish = function (response, comment) {
        // callback
        fdb_engine.locked = false; // UNLOCK
        qitem.qitem_promise_resolve(response); // PROMISE RESOLVE
        fdb_engine.queue_advance(); // Recursion CALL ITSELF
      };
      const on_qitem_error_catch = function (err) {
        // callback
        console.log(err);
        fdb_engine.locked = false; // UNLOCK
        qitem.qitem_promise_resolve(false); // PROMISE RESOLVE ??? REJECT
        fdb_engine.queue_advance(); // Recursion CALL ITSELF
      };
      const db_key = qitem.db_key;
      const dont_store = qitem.dont_store;
      const tid = qitem.transaction_id;
      // console.log('transaction ' + tid + ' ' + db_key + ' executing');
      ////

      // Two types of operation: 1) raad-mutate-write, 2) read-only
      // in 3 modes: MUTATE, COMBO, GET
      if (qitem.mode === MUTATE) {
        // CASE MUTATING OPERATIONS
        const mutator = qitem.mutator;
        // STEP read db
        fdb_engine.db_grab(db_key, dont_store)
          .then((db) => {
            // STEP mutate db
            let db_mutated = mutator(db, qitem.payload); // handle all mutating crud operation...
            return db_mutated;
          })
          .then((db_mutated) => {
            // STEP write mutated db
            // console.log('mutated data ' + tid + ' before write:');
            // console.log(db_mutated);
            if (js_utils.is_object(db_mutated)) {
              fdb_engine.db_write(db_mutated, db_key, dont_store);
              return true;
            }
            // skip mutation if mutator return false
            console.log('+++ mutator SKIP mutation by returning false in ' + tid + ' mutating operation! - no data will be writen. But fdb response is still success');
            return true;
          })
          .then((is_success) => {
            // STEP finish
            on_qitem_finish(is_success, 'qitem_promise is resolved CASE MUTATING');
          })
          .catch((err) => {
            console.error('+++ CATCH ERROR in ' + tid + ' mutating operation! :( ');
            console.log(err);
            on_qitem_error_catch(err);
          })

      } else if (qitem.mode === COMBO) {
        // CASE COMBINED OPERATIONS
        const combinator = qitem.combinator;
        // STEP read db
        fdb_engine.db_grab(db_key, dont_store)
          .then((db) => {
            // STEP mutate db
            let combined = combinator(db, qitem.payload); // handle combined operation...
            if (!Array.isArray(combined)) {
              combined = [false];
            }
            return combined;
          })
          .then((combined) => {
            // STEP write mutated db
            const [db_mutated, selected] = combined; // db_mutated = combined[0]; selected = combined[1];
            let combined_response = [];
            if (js_utils.is_object(db_mutated)) {
              fdb_engine.db_write(db_mutated, db_key, dont_store);
              // return true;
              combined_response.push(true); // index 0
            } else {
              // return false;
              // skip mutation if combined mutator return false
              console.log('+++ combinator SKIP mutation by returning false in ' + tid + ' combo operation! - no data will be writen. But fdb response is still success');
              combined_response.push(true); // index 0
            }
            combined_response.push(selected); // index 1
            return combined_response;
          })
          .then((combined_response) => {
            // STEP finish
            on_qitem_finish(combined_response, 'qitem_promise is resolved CASE COMBO');
          })
          .catch((err) => {
            console.error('+++ CATCH ERROR in ' + tid + ' combo operation! :( ');
            // console.log(err);
            on_qitem_error_catch(err);
          })

      } else if (qitem.mode === ADVANCED_SWAP) {
        // CASE ADVANCED_SWAP OPERATION
        const advanced_swap_anabled = qitem.advanced_swap_anabled;
        // STEP read db
        fdb_engine.db_grab(db_key, dont_store)
          .then((db) => {
            if (advanced_swap_anabled) {
              // BOOST ENABLE
              if (js_utils.is_object(db)) {
                // STEP write original db in temp vars
                fdb_engine.advanced_swap_enabled_db_keys[db_key] = true; // ENABLE
                fdb_engine.db_write(db, db_key, dont_store);
                return true;
              }
              return true;
            } else {
              // BOOST DISABLE
              if (js_utils.is_object(db)) {
                fdb_engine.advanced_swap_enabled_db_keys[db_key] = false; // DISABLE
                fdb_engine.db_write(db, db_key, dont_store);
                delete fdb_engine.advanced_swap_enabled_db_keys[db_key]; //
                delete fdb_engine.db_in_temp_vars[db_key] //
                return true;
              }
              return true;
            }
          })

        //////
        ////
        ///  

      } else {
        // CASE NON-MUTATING OPERATIONS (READ-ONLY)
        const selector = qitem.selector;
        // STEP read db
        fdb_engine.db_grab(db_key, dont_store)
          .then((db) => {
            // STEP read/select wanted data from db
            let selected;
            // console.log(selected);
            // console.log(selector === null);
            // console.log(typeof selector);
            if (typeof selector === 'function') {
              selected = selector(db, qitem.payload); // handle all non-mutating operation
            } else if (selector === null) {
              selected = db; // if selector is null return whole database
            }
            // console.log(selected);
            return selected;
          })
          .then((selected) => {
            // STEP finish
            on_qitem_finish(selected);
          })
          .catch((err) => {
            console.error('+++ CATCH ERROR in ' + tid + ' get (NON-mutating) operation! :( ');
            console.log(err);
            on_qitem_error_catch(err);
          })

      }
    } else {
      // CASE no items in queue
      fdb_engine.locked = false; // UNLOCK
    } // end of if
  } // end of if (fdb_engine.locked === false && fdb_engine.queue.length > 0)
}; // end of fdb_enige.queue_advance()


fdb_engine.do_operation = async function (mode, func, payload, db_key, dont_store) {
  // console.log('baza test 1')
  // console.log('DB OPERACIJA');
  // console.log(mode, func, db_key, dont_store);
  let result = false;
  let _dont_store = false;
  if (dont_store === true) {
    _dont_store = true;
  }
  // console.log(_mutating && typeof func === 'function')
  // console.log(typeof db_key === 'string', dont_store)
  /*
  if (((_mutating && typeof func === 'function') || (!_mutating && typeof func === 'function') || (!_mutating && func === null)) && typeof db_key === 'string' && db_key !== '') {
  */
  if ((typeof func === 'function' || func === null) && typeof db_key === 'string' && db_key !== '') {
    // console.log('baza test 2')
    // *****PROBLEM >>>>> Resolve promise when queue make callback
    let qitem_promise = new Promise((qitem_promise_resolve, reject) => {
      // executor
      const tid = fdb_engine.get_fresh_transaction_id();
      let query = {
        qitem_promise_resolve: qitem_promise_resolve,
        qitem_promise_reject: reject,
        db_key: db_key,
        dont_store: _dont_store,
        transaction_id: tid,
        payload: payload,
        mode: mode
      };
      // query.mutating = _mutating;
      if (mode === MUTATE) {
        query.mutator = func;
      } else if (mode === COMBO) {
        query.combinator = func;
      } else if (mode === ADVANCED_SWAP) {
        query.advanced_swap_anabled = func;
      } else {
        query.selector = func;
      }
      fdb_engine.queue.push(query);
      // console.log('transaction ' + tid + ' ' + db_key, dont_store, mode, ' added to queue');
      fdb_engine.queue_advance();
      // qitem_promise_resolve will be done by queue usign callback from queued tem
    });
    result = await qitem_promise; // callback converted to promise // waiting for callback
    // console.log('PROMISE RESOLVED');
    // console.log(result);
    // console.log(qitem_promise);

  }
  return result; // Promise resolve
};


// FRONTEND-DB SPECIAL INSTANCE (USING ENGINE)
// Every instance just storing database key and settings. All operation are done by same only engine.

let fdb = function (db_key, dont_store) {
  let instance = {}; // new instance...
  instance.db_key = db_key;
  instance.dont_store = false;
  if (dont_store === true) {
    instance.dont_store = true;
  }
  instance.get = async function (selector, payload) {
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    let result = await fdb_engine.do_operation(GET, selector, _payload, instance.db_key, instance.dont_store); // GET METHOD
    return result;
  };
  instance.mutate = async function (mutator, payload) {
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    let result = await fdb_engine.do_operation(MUTATE, mutator, _payload, instance.db_key, instance.dont_store); // MUTATE METOD
    return result;
  };
  instance.mutate_and_get = async function (combinator, payload) {
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    let result = await fdb_engine.do_operation(COMBO, combinator, _payload, instance.db_key, instance.dont_store); // COMBINED MUTATE AND GET METOD
    return result;
  };
  instance.advanced_boost_enabled = async function () {
    console.log('FDB advanced_boost_enabled()', instance.db_key);
    if (instance.dont_store === false) {
      const advanced_swap = true;
      let a = await fdb_engine.do_operation(ADVANCED_SWAP, advanced_swap, null, instance.db_key, instance.dont_store);
    } else {
      console.log('ERROR: FDB advanced_boost_enabled() can be enabled/disabled only for databases in storage', instance.db_key);
    }
    return true;
  };
  instance.advanced_boost_disabled = async function () {
    console.log('FDB advanced_boost_disabled()', instance.db_key);
    if (instance.dont_store === false) {
      const advanced_swap = false;
      let a = await fdb_engine.do_operation(ADVANCED_SWAP, advanced_swap, null, instance.db_key, instance.dont_store);
    } else {
      console.log('ERROR: FDB advanced_boost_disabled() can be enabled/disabled only for databases in storage', instance.db_key);
    }
    return true;
  };
  instance.delete_database = async function () {
    // console.log('FDB delete_database() method will now remove database completely', instance.db_key);
    let a = await fdb_engine.db_delete(instance.db_key);
    return true;
  };
  instance.info = function () {
    console.log('FDB INSTANCE INFO: ', instance.db_key, instance.dont_store);
    fdb_engine.queue_advance(); // REFRESH
  };
  return instance;
};


export default fdb;
// module.exports = fdb; // Node.js export default
export { fdb_engine };


/*
HOW TO USE

fdb(db_key, dont_store)
db_key argument is mandatory. it must be string...
dont_store OPTIONAL argument. Set true if you want advanced mode which store database in memory...


Example usage:
let mydatabase = fdb('my_first_database');
mydatabase.mutate(setMyInitialData);
mydatabase.info();
mydatabase.get(sellectAll);

or set parameters for every single call of methods

fdb('my_first_database').get(mySelector)
fdb('my_advanced_database', true).mutate(myMutator);
fdb('my_first_database').info();
fdb('my_first_database').delete_database();


Examples:

fdb('my_database_name').get(mySelector) // use default localstorage database with key 'my_database_name'

fdb('my_advanced_db', true).get(mySelector) // use advanced memory database with key 'my_advanced_db'

IMPORTANT! Even if you use same key if second parameters is different that will be 2 different databases.
For example:

fdb('my_database_name')
OR
fdb('my_database_name', false)
IS NOT THE SAME AS
fdb('my_database_name', true)



METHODS

.get(selector, payload)
- get method must receive first argument. First argument may be null or function (selector)
- second argument, payload, is optional.
- selector (reader) must receive db as first argument and return data as you wish
- if u provide payload argument to get method that payload will be used as second argument to your selector
- if u call get method with null .get(null) instead of selctor you will get whole database in return
- if database not exist you will get false in return.
- if u provide payload argument to get method that payload will be used as second argument to your selector

.mutate(mutator, payload)
- mutate method must receive first argument. First argument must be function (mutator)
- second argument, payload, is optional
- mutator must receive db as first argument and must return mutated db or false
- returned database must be object or changes will not be made
- if mutator return false, no chanes will be made
- if database not exist you will get false in return.
- if u provide payload argument to mutate method that payload will be used as second argument to your mutator

.mutate_and_get(combinator, payload)
- mutate_and_get method combine .mutate and .get methods in one
- mutate_and_get method must receive first argument. First argument must be function (combinator)
- second argument, payload, is optional
- combinator must return array with two item
[db, data]
- index 0 of returned array has same requirements as return of mutate method
- index 1 of returned array contain data like get method
- if u provide payload argument to mutate_and_get method that payload will be used as second argument to your combinator


.delete_database()
-delete database completely


.info()



- How to set initiial data for database?
Just make some kind of initial mutator functions. That initial mutator should not accept any arguments and return any object with yout initial content for database. FDB will write that content into database.
when you call .mutate(MyInitialMutator)
*** We prowide utility mutator for that. But you can write your own if you want something different.


- How to clone database from memory to localstorage or opposite?
You need to do it like copy-paste or export-import operation. First, read database and save it to your own variable. Than write that data into any database you like.


- How to move database from memory to localstorage or opposite?
Almost the same as clone operation but after you done with cloning, you need to delete one of the clones you dont need any more.


- Can i temporarely switch from localstorage mdoe to memory mode in one database?
Not by simple command, but you can do previously explained MOVE operation any time you want. So if you need that only temporarely than you move it and when that temporary perios passed you move it back again.


- (advanced chain - metod koji dodaje araray upita u bazi gde se rezultat svakog daje sledecem.)
- How to make connected chain of interdependent operations?
You just need to write mutator who will do internaly any number of operations you like. When your mutator is executing, database stay locked for any other operation. So chain of operations inside your mutator will stay interrupted.


*/


